import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, inject } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalMenu',
  setup(__props) {

const VerificationTab = inject<any>("VerificationTab");
const currentTab = inject<any>("currentTab");
const handleSelect = (VerificationTab) => {
  currentTab.value = VerificationTab;
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(currentTab),
    class: "mb-5",
    mode: "horizontal",
    onSelect: handleSelect
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).Info
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("fields.info")), 1)
        ]),
        _: 1
      }, 8, ["index"]),
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).Financial
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("fields.financial")), 1)
        ]),
        _: 1
      }, 8, ["index"]),
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).Agreement
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("fields.agreement")), 1)
        ]),
        _: 1
      }, 8, ["index"]),
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).Review
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("title.review")), 1)
        ]),
        _: 1
      }, 8, ["index"]),
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).PDF
      }, {
        default: _withCtx(() => [
          _createTextVNode("PDF")
        ]),
        _: 1
      }, 8, ["index"]),
      _createVNode(_component_el_menu_item, {
        index: _unref(VerificationTab).VerificationCode
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("fields.authenticationNumber")), 1)
        ]),
        _: 1
      }, 8, ["index"])
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})